/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HomeownershipRepresentation = {
    None: 'none',
    Own: 'own',
    Mainstay: 'mainstay'
} as const;
export type HomeownershipRepresentation = typeof HomeownershipRepresentation[keyof typeof HomeownershipRepresentation];


export function HomeownershipRepresentationFromJSON(json: any): HomeownershipRepresentation {
    return HomeownershipRepresentationFromJSONTyped(json, false);
}

export function HomeownershipRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipRepresentation {
    return json as HomeownershipRepresentation;
}

export function HomeownershipRepresentationToJSON(value?: HomeownershipRepresentation | null): any {
    return value as any;
}

